import { useEffect } from 'react';
import { useMatches } from '@tanstack/react-router';

import { useRouteText } from '@/lib/i18n/route-text';
import { composeRouteTitle } from '@/lib/route-title';

declare module '@tanstack/react-router' {
  interface StaticDataRouteOption {
    title?: string;
    parent?: { to: string; title: string };
    hideAppShell?: boolean;
  }
}

export function useDocumentTitle(dynamicLabel?: string | null): void {
  const matches = useMatches();
  const routeText = useRouteText();
  useEffect(() => {
    document.title = composeRouteTitle(
      matches.map((match) => match.staticData.title),
      routeText,
      dynamicLabel,
    );
  }, [matches, dynamicLabel, routeText]);
}
